<template>
  <div class="app-container">
    <!--form 组件-->
    <eForm ref="form" :is-add="isAdd" :sup-this="supThis" />
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="$refs.form.dialog = true;isAdd = true">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>

            <!-- <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"/> -->
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { del } from "@/api/certificate";
import eForm from "./form";
import { deepClone } from "@/utils/index";

export default {
  name: "Certificate",
  mixins: [DataTableMixin],
  components: {
    DynamicSearch,
    eForm
  },
  data() {
    return {
      delLoading: false,
      supThis: this,
      isAdd: false,
      form: {},
      dialogVisible: false,
      // 表格设置
      tableHead: [
        {
          label: "证书代码",
          prop: "code"
        },
        {
          label: "证书名称",
          prop: "name",
          query: {
            type: "input"
          },
          align: "left"
        },
        {
          label: "备注",
          prop: "remark"
        }
      ]
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/bsCredentials/findList";
      const premType = "3,4"; // 权限类型【前端权限】
      const params = { page: this.page, size: this.offset, type: premType };
      this._params = Object.assign(params, this._query);
      return true;
    },
    handleDeletes(rows) {
      rows.forEach(element => {
        this.subDelete(element.id);
      });
    },
    subDelete(id) {
      this.delLoading = true;
      del(id)
        .then(res => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleTableChangePage();
          this.dataTableInit();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
        })
        .catch(err => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err);
        });
    },
    edit(data) {
      this.isAdd = false;
      const _this = this.$refs.form;
      _this.form = deepClone(data);
      _this.dialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
</style>